import { Helmet } from "react-helmet-async";
import React, { useContext } from "react";
import { MetadataContext } from "../Contexts/MetadataContext";
import { useLocation } from "react-router-dom";
import { getPageTypeId } from "../Utils/pageMap";

export default function Meta() {
  const { metadata, dynamicMeta, loading } = useContext(MetadataContext);
  const location = useLocation();

  if (loading) return null;

  // 🔥 PRIORITY:
  // 1. Product / Category (dynamicMeta)
  // 2. Static pages (MetaData table)
  // 3. Fallback

  let meta = dynamicMeta;

  if (!meta) {
    const pageTypeId = getPageTypeId(location.pathname);
    const metaArray = metadata ? Object.values(metadata) : [];

    meta =
      metaArray.find(m => m.Page === pageTypeId) || {
        Title: "Home Dopot | Tiles, Ceramics & Sanitary Ware",
        Description:
          "Discover premium tiles, ceramics, bathroom sinks, and sanitary ware at Home Dopot.",
        Keywords:
          "tiles, ceramics, sanitary ware, bathroom sinks, home finishing",
        Url: window.location.href,
        Type: "website",
        Image: "",
        TwitterCard: "summary_large_image",
      };
  }

  return (
    <Helmet>
      <title>{meta.Title}</title>
      <meta name="title" content={meta.Title} />
      <meta name="description" content={meta.Description} />
      <meta name="keywords" content={meta.Keywords} />

      {/* Open Graph */}
      <meta property="og:title" content={meta.Title} />
      <meta property="og:description" content={meta.Description} />
      <meta property="og:type" content={meta.Type} />
      <meta property="og:url" content={meta.Url} />
      <meta property="og:image" content={meta.Image} />

      {/* Twitter */}
      <meta name="twitter:card" content={meta.TwitterCard} />
      <meta name="twitter:title" content={meta.Title} />
      <meta name="twitter:description" content={meta.Description} />
      <meta name="twitter:image" content={meta.Image} />
    </Helmet>
  );
}
